import type { FC } from 'react';

import { Copy01 as Component } from '@untitledui-pro/icons/solid/Copy01';

import { BaseIcon, type IconProps } from '../../base-icon/base-icon.tsx';

export type Copy01Props = IconProps;

export const Copy01: FC<Copy01Props> = (props) => <BaseIcon {...props} Component={Component} />;
